export enum MapViewAction {
  Move,
  Zoom
}
